import styled from '@emotion/styled';
import { Variables } from '../../../base/variables/variables';

/** Bottom-right so it does not collide with BatchUploadWidget (top-right). */
export const WidgetContainer = styled.div`
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 1300;
    width: min(360px, calc(100vw - 32px));
    background: ${Variables.Colors.white};
    border: 1px solid ${Variables.Colors.nx8};
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px 16px;
`;

export const WidgetHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
`;

export const WidgetTitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const WidgetTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
`;

export const WidgetSubtitle = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.n50};
`;

export const ProgressTrack = styled.div`
    width: 100%;
    height: 6px;
    border-radius: 3px;
    background: ${Variables.Colors.n5};
    overflow: hidden;
`;

export const ProgressBar = styled.div<{ value: number }>`
    height: 100%;
    width: ${p => Math.min(100, Math.max(0, p.value))}%;
    background: ${Variables.Colors.b300};
    border-radius: 3px;
    transition: width 0.2s ease;
`;

export const WidgetActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
`;
